import { Outlet } from 'react-router-dom'

import { MyTrainingsCatalogPermissionDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { NewCatalogDataCollection } from 'modules/trainings/components/NewCatalogDataCollection'

const Catalog = () => {
  const { loading, data, error } = useQuery(MyTrainingsCatalogPermissionDocument)

  const authorized =
    data?.trainings._policies.trainingsSeeCatalog.can &&
    data?.trainings._policies.trainingsRequestsCreate.can

  return (
    <ResponsivePage.Body loading={loading} error={error} authorized={authorized}>
      <NewCatalogDataCollection />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default Catalog
